import type { ReactNode } from "react";
import { Inbox } from "lucide-react";

interface EmptyStateProps {
    icon?: ReactNode;
    title?: string;
    hint?: string;
    size?: "lg" | "sm";
}

// Shared empty-state placeholder for list/kanban/calendar bodies and for any
// per-column empty in a kanban board. Hollow brand-tinted icon + short title +
// optional hint, centered on the surface. `size="sm"` is used inside kanban
// columns (no hint, smaller icon) so it fits the column width.
export function EmptyState({
    icon,
    title = "No records",
    hint,
    size = "lg",
}: EmptyStateProps) {
    const iconSize = size === "sm" ? 28 : 56;
    return (
        <div className={`empty-state empty-state--${size}`}>
            <div className="empty-state__icon">
                {icon ?? <Inbox size={iconSize} strokeWidth={1.2} />}
            </div>
            <div className="empty-state__title">{title}</div>
            {hint ? <div className="empty-state__hint">{hint}</div> : null}
        </div>
    );
}
